<template>
  <div class="lightbox">
    <div class="lightbox__content">
      <img :src="currentImage" alt="" />
    </div>
    <IconButton :disabled="prevDisabled" @click.native="previous" class="lightbox__prev">
      <font-awesome-icon icon="chevron-left" />
    </IconButton>
    <IconButton :disabled="nextDisabled" @click.native="next" class="lightbox__next">
      <font-awesome-icon icon="chevron-right" />
    </IconButton>
    <IconButton :disabled="false" @click.native="close" class="lightbox__close">
      <font-awesome-icon icon="times" />
    </IconButton>
    <div class="lightbox__reel"></div>
  </div>
</template>

<script>
import IconButton from './IconButton.vue';

export default {
  name: 'Lightbox',
  components: { IconButton },
  props: {
    images: {
      type: Array,
      required: true,
    },
    selected: Number,
  },
  data: () => ({
    currentIndex: null,
  }),
  computed: {
    imageCount() {
      return this.images.length;
    },
    prevDisabled() {
      return this.currentIndex < 1;
    },
    nextDisabled() {
      return this.currentIndex > this.imageCount - 2;
    },
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    previous() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    next() {
      if (this.currentIndex < this.imageCount - 1) {
        this.currentIndex++;
      }
    },
    close() {
      this.$emit('close');
    },
  },
  created() {
    this.currentIndex = this.selected || 0;
  },
};
</script>

<style>
.lightbox {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100;
  justify-content: center;
}

.lightbox__content {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.lightbox__content > img {
  max-height: 100%;
  margin: auto;
}

.lightbox__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.lightbox__prev {
  position: absolute;
  top: 50%;
  left: 1rem;
}

.lightbox__next {
  position: absolute;
  top: 50%;
  right: 1rem;
}
</style>
